import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_triangle_down",
  "use": "icon-icon_triangle_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_triangle_down\">\n  <path d=\"M234.88884163 377.47806845l279.65492248 279.65492248 278.8075161-278.8075161z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/svg/icon_triangle_down.svg
// module id = u2ZU
// module chunks = 1